module.exports = __webpack_public_path__ + "58e386331ec25ce645178d24d0ac06a5.png";